import { ElementType, FC, SyntheticEvent } from 'react';
import { Box, BoxProps, Flex, Link, Text } from '@chakra-ui/react';
import { CbAvatar } from '../CbAvatar';
import { CbNotificationAlertBell } from '../CbNotificationAlertBell';
export interface ViewProfileBoxProps extends CbProfileWidgetProps {
  maxWidth?: string | number;
}
export const ViewProfileBox: FC<ViewProfileBoxProps> = ({
  as,
  href,
  image,
  name,
  text,
  onClick,
  maxWidth
}) => {
  const content = <Link href={href} onClick={onClick} _hover={{
    color: 'text.hint'
  }} _activeLink={{
    color: 'text.hint'
  }}>
      <Flex alignItems="center">
        <CbAvatar width={8} height={8} name={name} image={image} borderRadius={2} />
        <Flex direction="column" marginLeft={3} maxWidth={maxWidth}>
          <Text fontSize="sm" fontWeight={600} color="white" lineHeight="base" noOfLines={1}>
            {name}
          </Text>
          <Text color="cloud.500" fontSize="xs" lineHeight="shorter" noOfLines={1}>
            {text || 'View profile'}
          </Text>
        </Flex>
      </Flex>
    </Link>;
  if (as) {
    return <Link as={as} href={href}>
        {content}
      </Link>;
  }
  return content;
};
export interface CbProfileWidgetProps extends BoxProps {
  as?: ElementType;
  href?: string;
  image?: string;
  name?: string;
  text?: string;
  notificationCount?: number;
  onClick?: (event: SyntheticEvent) => void;
}
export const CbProfileWidget: FC<CbProfileWidgetProps> = ({
  notificationCount,
  ...props
}) => {
  const paddingRight = notificationCount ? 1 : 4;
  const maxWidth = notificationCount ? 24 : '8.5rem';
  return <Box paddingY="12px" backgroundColor="luigisPants.600" borderRadius={8} maxWidth="xs" {...props} data-sentry-element="Box" data-sentry-component="CbProfileWidget" data-sentry-source-file="CbProfileWidget.tsx">
      <Flex justifyContent="space-between" paddingLeft={3} paddingRight={paddingRight} alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CbProfileWidget.tsx">
        <ViewProfileBox {...props} maxWidth={maxWidth} data-sentry-element="ViewProfileBox" data-sentry-source-file="CbProfileWidget.tsx" />
        <Flex data-sentry-element="Flex" data-sentry-source-file="CbProfileWidget.tsx">
          {notificationCount && <CbNotificationAlertBell href="/" count={notificationCount} />}
        </Flex>
      </Flex>
    </Box>;
};